import i18next from 'i18next';
import XHR from "i18next-xhr-backend";
import {data} from './loadJSON';


i18next.use(XHR).init({
        lng: window.userLang,
        fallbackLng: window.userLang,
        debug: true,
        resources: {
            it: {
                translation: data
            },
            en: {
                translation: data
            }
        }
    }, function(err, t) {
        // init set content
        const language =
            (navigator.languages && navigator.languages[0]) ||
            navigator.language ||
            navigator.userLanguage;

    });

export default i18next;
